<div class="container mt-3">
    <div class="cssmtgb just_center">
        <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
            (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Ozow Payment">
                <div class="container mt-3 ozow-payment">
                    <div class="row">
                        <div class="col-12">
                            <span class="title_header_bar">Ozow Payment</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="ozow-toolbar d-flex flex-wrap align-items-center justify-content-between mt-3">
                            <div class="ozow-toolbar-actions d-flex flex-wrap align-items-center">
                                <app-button (refreshClicked)="Refresh()" class="mb-2"></app-button>
                                <button type="button" class="btn btn-secondary mb-2 mr-3"
                                    (click)="exportOzowTransactions()"
                                    [disabled]="filteredOzowTransactions.length === 0">
                                    <i class="fa fa-download"></i> Export
                                </button>
                                <button type="button" class="btn btn-primary mb-2"
                                    (click)="ozowFiltersOpen = !ozowFiltersOpen">
                                    <i class="fa" [ngClass]="ozowFiltersOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    <span class="ml-2">Filter</span>
                                </button>
                            </div>
                            <div class="ozow-search-field">
                                <input #ozowSearchInput [value]="ozowSearchTerm"
                                    (input)="onOzowSearch(ozowSearchInput.value)" placeholder="Search"
                                    aria-label="Search transactions">
                                <button type="button" class="ozow-search-button" aria-label="Search transactions"
                                    (click)="onOzowSearch(ozowSearchInput.value)">
                                    <mat-icon>search</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class="ozow-filter-panel" *ngIf="ozowFiltersOpen">
                            <div class="ozow-filter-title">Filter</div>
                            <div class="ozow-filter-grid">

                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>Transaction Start Date</mat-label>
                                    <input matInput [matDatepicker]="ozowStartDatePicker" [max]="date"
                                        [value]="ozowDateFrom"
                                        (dateChange)="onOzowDateFilterChange('from', $event.value)"
                                        placeholder="Select Start Date" (click)="ozowStartDatePicker.open()" readonly>
                                    <mat-datepicker-toggle matSuffix [for]="ozowStartDatePicker">
                                        <mat-icon matDatepickerToggleIcon>event</mat-icon>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #ozowStartDatePicker></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>Transaction End Date</mat-label>
                                    <input matInput [matDatepicker]="ozowEndDatePicker" [max]="date"
                                        [min]="ozowDateFrom" [value]="ozowDateTo"
                                        (dateChange)="onOzowDateFilterChange('to', $event.value)"
                                        placeholder="Select End Date" (click)="ozowEndDatePicker.open()" readonly>
                                    <mat-datepicker-toggle matSuffix [for]="ozowEndDatePicker">
                                        <mat-icon matDatepickerToggleIcon>event</mat-icon>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #ozowEndDatePicker></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Status</mat-label>
                                    <mat-select [value]="ozowStatusFilter"
                                        (selectionChange)="onOzowStatusFilterChange($event.value)">
                                        <mat-option value="">All statuses</mat-option>
                                        <mat-option *ngFor="let status of ozowStatusOptions" [value]="status.key">
                                            {{ status.value }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="d-flex justify-content-end button-style mt-3">
                                <button type="button" class="btn reset_btn mb-3 mr-3" (click)="clearOzowFilters()">
                                    <i class="fa fa-refresh"></i> Reset
                                </button>
                                <button type="button" class="btn btn-secondary mb-3" (click)="applyOzowFilters()">
                                    <i class="fa fa-search"></i> Search
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive table-container mt-4 mb-2">
                            <mat-table [dataSource]="pagedOzowTransactions" class="mat-table">
                                <ng-container matColumnDef="customer">
                                    <mat-header-cell *matHeaderCellDef>Customer Details</mat-header-cell>
                                    <mat-cell *matCellDef="let transaction">
                                        <div class="ozow-customer">
                                            <strong>{{ transaction.customerName }}</strong>
                                            <span>{{ transaction.email }}</span>
                                            <span>{{ transaction.contact }}</span>
                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="transaction">
                                    <mat-header-cell *matHeaderCellDef>Payment ID </mat-header-cell>
                                    <mat-cell *matCellDef="let transaction">
                                        <div class="ozow-customer">
                                            <strong>{{ transaction.paymentId }}</strong>
                                            <span>{{ transaction.merchantReference }}</span>
                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="date">
                                    <mat-header-cell *matHeaderCellDef>Transaction date</mat-header-cell>
                                    <mat-cell *matCellDef="let transaction">
                                        {{ transaction.createdAt ? (transaction.createdAt | date:'dd/MM/yyyy HH:mm:ss')
                                        : '-' }}
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="amount">
                                    <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
                                    <mat-cell *matCellDef="let transaction">
                                        R {{ transaction.amount }}
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="status">
                                    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                                    <mat-cell *matCellDef="let transaction">
                                        <span class="ozow-status"
                                            [ngClass]="getOzowStatusClass(transaction.paymentStatusTypeDesc)">
                                            {{ transaction.paymentStatusTypeDesc }}
                                        </span>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                                    <mat-cell *matCellDef="let transaction">
                                        <button type="button" class="btn btn-primary ozow-view-button"
                                            (click)="viewOzowTransaction(transaction)">View</button>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="ozowDisplayedColumns; sticky: true"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: ozowDisplayedColumns"></mat-row>
                            </mat-table>
                            <div *ngIf="ozowLoading" class="no-data-message">Loading transactions...</div>
                            <div *ngIf="!ozowLoading && ozowErrorMessage" class="no-data-message ozow-error">
                                {{ ozowErrorMessage }}
                            </div>
                            <div *ngIf="!ozowLoading && !ozowErrorMessage && filteredOzowTransactions.length === 0"
                                class="no-data-message">No data found</div>
                        </div>

                        <mat-paginator [length]="ozowTotalCount" [pageIndex]="ozowPageIndex" [pageSize]="ozowPageSize"
                            [pageSizeOptions]="[50, 100]" (page)="onOzowPageChange($event)" showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Snap Scan Payment">
                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Snap Scan Payment</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="d-flex justify-content-between button-style mt-3">
                            <!-- <button class="btn btn-secondary mb-3 mr-3" type="button" (click)="Refresh()" matButton><i
                                    class="fa fa-refresh"></i> Refresh</button> -->
                            <app-button (refreshClicked)="Refresh()" class="mb-3 mr-3"></app-button>

                            <button type="button" class="btn btn-primary mr-3  d-flex"
                                (click)="filtershow = !filtershow">
                                <ng-container *ngIf="!filtershow">
                                    <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                                </ng-container>
                                <ng-container *ngIf="filtershow">
                                    <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
                                </ng-container>
                                <span class="ml-2">Filter</span>
                            </button>
                        </div>
                        <div [@detailExpand]="filtershow ? 'expanded' : 'collapsed'" style="overflow: hidden;">
                            <hr>
                            <div class="subtitle_header ml-5">Filter</div>
                            <form [formGroup]="form" class="mx-5">

                                <div class="row">
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Status</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="status"
                                                placeholder="Select Primary Product ">
                                                <mat-select-filter [displayMember]="'value'" [array]="statusList"
                                                    (filteredReturn)="statusList = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of statusList" [value]="item.value"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Customer Number</mat-label>
                                            <input matInput maxlength="15" placeholder="Search by CustomerNumber"
                                                formControlName="merchantReference" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                            <mat-label>Transaction Start Date</mat-label>
                                            <input matInput [matDatepicker]="startDatePicker"
                                                formControlName="transactionStartDate" autocomplete="off"
                                                (dateChange)="startdate()" placeholder="Select Start Date"
                                                class="custom-input-border" (click)="startDatePicker.open()" readonly
                                                [max]="date">
                                            <mat-datepicker-toggle matSuffix [for]="startDatePicker"
                                                style="color:black;">
                                                <button mat-icon-button>
                                                    <mat-icon>event</mat-icon>
                                                </button>
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #startDatePicker></mat-datepicker>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                            <mat-label>Transaction End Date</mat-label>
                                            <input matInput [matDatepicker]="endDatePicker" [max]="date" [min]="mindate"
                                                formControlName="transactionEndDate" autocomplete="off"
                                                placeholder="Select End Date" class="custom-input-border"
                                                (click)="endDatePicker.open()" readonly>
                                            <mat-datepicker-toggle matSuffix [for]="endDatePicker" style="color:black;">
                                                <button mat-icon-button>
                                                    <mat-icon>event</mat-icon>
                                                </button>
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #endDatePicker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end button-style mt-3">
                                    <button class="btn reset_btn mb-3 mr-3" type="button" (click)="clearFilter()"
                                        matButton><i class="fa fa-refresh"></i> Reset</button>
                                    <button class="btn btn-secondary mb-3" type="submit" (click)="filter()" matButton><i
                                            class="fa fa-search"></i> Search</button>
                                </div>
                            </form>
                        </div>
                        <div>
                            <div class="table-responsive table-container mt-4 mb-4">
                                <mat-table #table [dataSource]="dataSource" class="mat-table ">

                                    <ng-container matColumnDef="CustomerNumber">
                                        <mat-header-cell *matHeaderCellDef
                                            style="text-align: center;">CustomerNumber</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 4%;text-align: center;">
                                            <p class="text-truncate txtalign"> {{dataField.merchantReference}}</p>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="BankReference">
                                        <mat-header-cell *matHeaderCellDef style="text-align: center;"> Bank
                                            Reference</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 12%;text-align: center;">
                                            <p class="text-truncate txtalign">{{dataField.statementReference}} </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="TransactionCode">
                                        <mat-header-cell *matHeaderCellDef style="text-align: center;">Transaction
                                            Code</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 5%; text-align: center;">
                                            <p class="text-truncate txtalign">{{dataField.authCode}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="TransactionDate">
                                        <mat-header-cell *matHeaderCellDef style="text-align: center;">Transaction
                                            Date</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                            <p class="text-truncate txtalign">{{dataField.date |
                                                date:'dd/MM/yyyyHH:mm:ss'}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="Status">
                                        <mat-header-cell *matHeaderCellDef
                                            style="text-align: center;">Status</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                            <p class="text-truncate txtalign">{{dataField.status}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="TotalAmount">
                                        <mat-header-cell *matHeaderCellDef style="margin:0;padding:0">Total
                                            Amount</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                            <p class="text-truncate txtalign">R {{dataField.totalAmount/100}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="FeeAmount">
                                        <mat-header-cell *matHeaderCellDef>Fee Amount</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                            <p class="text-truncate txtalign">R {{dataField.feeAmount/100}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="SettleAmount">
                                        <mat-header-cell *matHeaderCellDef>Settle Amount</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                            <p class="text-truncate txtalign">R {{dataField.settleAmount/100}}</p>
                                        </mat-cell>
                                    </ng-container>

                                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                                    <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                                    </mat-row>
                                </mat-table>
                                <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                                    <p>No data found</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Credit Card Payment">
                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Credit Card Payment</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="d-flex justify-content-between button-style mt-3">
                            <!-- <button class="btn btn-secondary mb-3 mr-3" type="button" (click)="Refresh()" matButton><i
                                    class="fa fa-refresh"></i> Refresh</button> -->
                            <app-button (refreshClicked)="Refresh()" class="mb-3 mr-3"></app-button>

                            <button type="button" class="btn btn-primary mr-3  d-flex"
                                (click)="filtershow = !filtershow">
                                <ng-container *ngIf="!filtershow">
                                    <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                                </ng-container>
                                <ng-container *ngIf="filtershow">
                                    <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
                                </ng-container>
                                <span class="ml-2">Filter</span>
                            </button>
                        </div>
                        <div [@detailExpand]="filtershow ? 'expanded' : 'collapsed'" style="overflow: hidden;">
                            <hr>
                            <div class="subtitle_header ml-5">Filter</div>
                            <form [formGroup]="form" class="mx-5">

                                <div class="row">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Search By Text</mat-label>
                                            <input matInput placeholder="Search by CustomerNumber / CustomerName"
                                                formControlName="merchantReference" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                            <mat-label>Transaction Start Date</mat-label>
                                            <input matInput [matDatepicker]="startDatePicker1" [max]="date"
                                                formControlName="transactionStartDate" autocomplete="off"
                                                placeholder="Select Start Date" class="custom-input-border"
                                                (click)="startDatePicker1.open()" (dateChange)="startdate()" readonly>
                                            <mat-datepicker-toggle matSuffix [for]="startDatePicker1"
                                                style="color:black;">
                                                <button mat-icon-button>
                                                    <mat-icon>event</mat-icon>
                                                </button>
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #startDatePicker1></mat-datepicker>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                            <mat-label>Transaction End Date</mat-label>
                                            <input matInput [matDatepicker]="endDatePicker1" [max]="date"
                                                [min]="mindate" formControlName="transactionEndDate" autocomplete="off"
                                                placeholder="Select End Date" class="custom-input-border"
                                                (click)="endDatePicker1.open()" readonly>
                                            <mat-datepicker-toggle matSuffix [for]="endDatePicker1"
                                                style="color:black;">
                                                <button mat-icon-button>
                                                    <mat-icon>event</mat-icon>
                                                </button>
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #endDatePicker1></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end button-style mt-3">
                                    <button class="btn reset_btn mb-3 mr-3" type="button" (click)="clearFilter()"
                                        matButton><i class="fa fa-refresh"></i> Reset</button>
                                    <button class="btn btn-secondary mb-3" type="submit" (click)="filter()" matButton><i
                                            class="fa fa-search"></i> Search</button>
                                </div>
                            </form>
                        </div>
                        <div class="table-responsive table-container mt-4 mb-4">
                            <mat-table #table [dataSource]="dataSource" class="mat-table ">
                                <ng-container matColumnDef="CustomerName">
                                    <mat-header-cell *matHeaderCellDef style="text-align: center;"> Customer
                                        Name</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;text-align: center;">
                                        <p class="text-truncate txtalign">{{dataField.fullName}} </p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="CustomerNumber">
                                    <mat-header-cell *matHeaderCellDef
                                        style="text-align: center;">CustomerNumber</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;text-align: center;">
                                        <p class="text-truncate txtalign"> {{dataField.merchantReference}}</p>
                                    </mat-cell>
                                </ng-container>


                                <ng-container matColumnDef="TransactionCode">
                                    <mat-header-cell *matHeaderCellDef style="text-align: center;">Transaction
                                        Code</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 5%; text-align: center;">
                                        <p class="text-truncate txtalign">{{dataField.transactionCode}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="TransactionDate">
                                    <mat-header-cell *matHeaderCellDef style="text-align: center;">Transaction
                                        Date</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                        <p class="text-truncate txtalign">{{dataField.transactionTimeStamp |
                                            date:'dd/MM/yyyy HH:mm:ss'}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Status">
                                    <mat-header-cell *matHeaderCellDef
                                        style="text-align: center;">Status</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 15%;text-align: center;">
                                        <p class="text-truncate txtalign">{{dataField.status}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="TotalAmount">
                                    <mat-header-cell *matHeaderCellDef style="text-align: center;">Total
                                        Amount</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 4%; text-align: center;">
                                        <p class="text-truncate txtalign">R {{dataField.amount | number: '1.3-3'}}</p>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="displayedColumns1; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns1;  " matRipple>
                                </mat-row>
                            </mat-table>
                            <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                                <p>No data found</p>
                            </div>
                        </div>
                    </div>
                </div>

            </mat-tab>
        </mat-tab-group>
        <div class="ozow-modal-backdrop" *ngIf="selectedOzowTransaction as transaction" (click)="closeOzowDetails()">
            <section class="ozow-modal" role="dialog" aria-modal="true" aria-labelledby="ozow-details-title"
                (click)="$event.stopPropagation()">
                <header class="ozow-modal-header">
                    <h2 id="ozow-details-title">Ozow transaction details</h2>
                    <button type="button" class="ozow-modal-close" aria-label="Close details"
                        (click)="closeOzowDetails()">&times;</button>
                </header>
                <div class="ozow-details-grid">
                    <div class="ozow-payment-url">
                        <span>Payment URL</span>
                        <a *ngIf="isHttpPaymentUrl(transaction.paymentUrl); else paymentUrlText"
                            [href]="transaction.paymentUrl" target="_blank" rel="noopener noreferrer">
                            {{ transaction.paymentUrl }}
                        </a>
                        <ng-template #paymentUrlText><strong>{{ transaction.paymentUrl }}</strong></ng-template>
                    </div>
                    <div><span>Payment ID</span><strong>{{ transaction.paymentId }}</strong></div>
                    <div><span>Transaction ID</span><strong>{{ transaction.transactionId }}</strong></div>

                    <div><span>Customer name</span><strong>{{ transaction.customerName }}</strong></div>
                    <div><span>Customer code</span><strong>{{ transaction.customerCode }}</strong></div>
                    <div><span>Site code</span><strong>{{ transaction.siteCode }}</strong></div>
                    <div><span>Country code</span><strong>ZA</strong></div>
                    <div><span>Email</span><strong>{{ transaction.email }}</strong></div>
                    <div><span>Contact</span><strong>{{ transaction.contact }}</strong></div>
                    <div><span>Merchant reference</span><strong>{{ transaction.merchantReference }}</strong></div>
                    <div><span>Payment method</span><strong>{{ transaction.paymentMethod }}</strong></div>
                    <div><span>Amount</span><strong>{{ transaction.amount }}</strong></div>
                    <div><span>Status</span><strong>{{ transaction.paymentStatusTypeDesc }}</strong></div>
                    <div><span>Created at</span><strong>{{ transaction.createdAt ? (transaction.createdAt |
                            date:'dd/MM/yyyy HH:mm:ss') : '-' }}</strong></div>
                </div>
            </section>
        </div>
    </div>
</div>